import { client } from '@/common-utils/libraries/axios/axios';
import MERCHANT_USER from '../apiUrls';

const mutationResetUsersPassword = (onSuccess, onError) => {
    return {
        mutationFn: ({ token }) => {
            return client.post(MERCHANT_USER.RESET_PASSWORD_USERS.url, { token });
        },
        // onError: (error, variables, context)
        onError: (error) => {
            onError(error);
        },
        // onSuccess: (data, variables, context)
        onSuccess: () => {
            onSuccess();
        },
        // onSettled: (data, error, variables, context)
        onSettled: () => {
            // Error or success... doesn't matter!
        }
    };
};

export default mutationResetUsersPassword;